import React from "react";
import RenderTabs from "../../../../../components/ui/tabs/RenderTabs";
import TeamProjects from "../../TeamProjects";
import TeamMembers from "../../../../teamMembers/TeamMembers";

const TeamDetailsTabs = (props) => {
  const tabs = [
    {
      sMenuItemCaption: "Team Member Management",
      icon: "fluent:people-team-toolbox-20-regular",
      component: <div className="2"><TeamMembers teamId={props.teamId} responsibleUser={props.responsibleUser} /></div>,
    },
    {
      sMenuItemCaption: "Team Project",
      icon: "octicon:project-symlink-24",
      component: <div className=""><TeamProjects teamId={props.teamId} /></div>,
    },
  ];

  return (
    <>
      <div className="col-12">
        <div className="tab-header-padding">
          <RenderTabs tabs={tabs} />
        </div>
      </div>
    </>
  );
};

export default TeamDetailsTabs;
